/**
 * 基础路由
 * @type { *[] }
 */
import {
  BlankLayout
} from '@/layouts'
export default {
  path: '/user',
  component: BlankLayout,
  redirect: '/user/login',
  hidden: true,
  children: [{
    path: 'login',
    redirect: 'login',
    component: () => import('@/views/Home/index')
  },
  {
    path: '/403',
    name: '403',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/Exception/403')
  }
  ]
}
